// Supporter packages: yearly price in NOK excl. VAT. Launch price = 50% off for the first 50 supporters.
export const SUPPORT_PACKAGES = [
  { key: "local", trolls: 1, launch: 12900, regular: 25800 },
  { key: "business", trolls: 5, launch: 49000, regular: 98000 },
  { key: "destination", trolls: 10, launch: 79000, regular: 158000, popular: true },
  { key: "region", trolls: 20, launch: 99000, regular: 198000 },
];

export const VIPPS_NUMBER = "96883754";
export const fmtVipps = (n) => n.replace(/(\d{3})(\d{2})(\d{3})/, "$1 $2 $3");
// Free host listing: one place on the map, no payment.
export const HOST_PACKAGE = { key: "host", trolls: 1, launch: 0, regular: 0, free: true };
export const SIGNUP_PACKAGES = [...SUPPORT_PACKAGES, HOST_PACKAGE];
export const pkgByKey = (k) => SIGNUP_PACKAGES.find((p) => p.key === k);
export const priceOf = (pkg) => {
  const vat = Math.round(pkg.launch * 0.25);
  return { ex: pkg.launch, vat, total: pkg.launch + vat };
};
